import React, { FC } from 'react';
import { View, Text } from 'react-native';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { SmallLoading } from '@components/loading';
import { isWeb } from '@helpers';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export interface ShowMoreButtonProps {
  C: ColorFunction;
  showMoreSize: number;
  load?: (params?: any) => Promise<void>;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  showMoreText: string;
  showMoreArrow: boolean;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

const ShowMoreButton: FC<ShowMoreButtonProps> = ({
  C,
  showMoreSize,
  load,
  loading,
  setLoading,
  showMoreText,
  showMoreArrow,
  scale = initialScale,
  font = initialFont
}) => {
  return (
    <View
      style={{
        width: '100%',
        height: scale(showMoreSize),
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: C('Background / Light / Field'),
        borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS),
        borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS),
      }}
    >
      <TouchableElement
        hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }}
        onPress={async () => {
          if (load && !loading) {
            setLoading(true);
            await load();
            setLoading(false);
          }
        }}
      >
        {({ boxStyle, pressHoverColor }) =>
          loading ? (
            <View>
              <SmallLoading />
            </View>
          ) : (
            <View
              style={[
                boxStyle,
                {
                  backgroundColor: C('Button / Light / Tertiary'),
                  paddingRight: scale(15),
                  paddingLeft: scale(15),
                  height: scale(28),
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: scale(15),
                  marginLeft: scale(-15),
                  flexDirection: 'row',
                },
              ]}
            >
              <Text
                style={[
                  {
                    color: C('Label/Light/Secondary'),
                  },
                  font['Button 2'],
                ]}
              >
                {showMoreText}
              </Text>
              {showMoreArrow && (
                <View
                  style={{
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    transform: [{ rotate: '90deg' }],
                    marginLeft: scale(8),
                    marginTop: scale(isWeb ? 2 : 0),
                  }}
                >
                  <Svg icon="chevronRightLight" color="Label/Light/Tertiary" width={scale(isWeb ? 10 : 12)} height={scale(isWeb ? 12 : 15)} />
                </View>
              )}
            </View>
          )
        }
      </TouchableElement>
    </View>
  );
};

export default ShowMoreButton;
